import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { get, map, times /*, sum, size,  includes */ } from "lodash";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

import { ZONE_TYPE, ZONE_TYPES_WITH_INVENTORY_ICON } from "../../constants/zones";

const styles = {
  zoneCell: {
    height: "32px",
    lineHeight: 1,
  },
  zoneCellSelected: {
    height: "32px",
    backgroundColor: colors.activeYellow + " !important",
    lineHeight: 1,
  },
  spacer: {
    width: "18px"
  },
  zoneDescription: {
    cursor: "pointer",
    alignItems: "baseline"
  },
  zoneText: {
    color: colors.black,
  },
  zoneTypeText: {
    color: colors.black54,
    fontSize: "10px",
    marginLeft: "3px"
  },
  zoneChildCount: {
    marginLeft: "3px",
    color: colors.black,
  },
  whiteBg: {
    backgroundColor: colors.white,
  },
  activeItem: {
    color: colors.black87,
    fontWeight: 500,
  },
  inactiveItem: {
    color: colors.black54,
    fontStyle: "italic",
  },
  arrowItem: {
    width: "12px",
    marginRight: "4px",
    cursor: "pointer",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: colors.lightGreenBg + " !important",
    },
  }
};

const ZoneTreeRow = withStyles(styles)((props) => {
  const {
    history,
    classes,
    branch,
    depth,
    language,
    expandedZones,
    onExpand,
    selectedZone,
    goTo,
    scrollToSelected,
    setScrollToSelected,
  } = props;

  const expanded = expandedZones ? expandedZones.includes(get(branch, ["id"])) : false;
  const expandable = Array.isArray(branch.childs) && branch.childs.length > 0;
  
  const zoneRef = React.useRef(null);

  React.useEffect(() => {
    checkForScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    checkForScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToSelected]);

  const checkForScroll = () => {
    if (get(branch, ["id"]) === selectedZone) {
      if (scrollToSelected && zoneRef.current) {
        zoneRef.current.scrollIntoView();
        setScrollToSelected(false);
      }
    }
  }

  const expandRow = (e) => {
    e.stopPropagation();
    if (expandable) {
      onExpand(get(branch, ["id"]));
    }
  };

  const navigateToBranch = (e) => {
    e.stopPropagation();
    if (get(branch, ['id']) === selectedZone) return;
    goTo(get(branch, ["id"]));
  };

  const renderZoneRow = () => {
    //const hasChilds = size(get(branch, ["childs"])) > 0;
    const zoneType = get(branch, ["type"]);
    const zoneName = get(zoneType, [`name_${language}`])
    return (
      <TableCellStyled ref={zoneRef} className={get(branch, ["id"]) === selectedZone ? classes.zoneCellSelected : classes.zoneCell}>
        <Grid container alignItems="center" wrap="nowrap">
          {times(depth, (i) => (
            <Grid item className={classes.spacer} key={i} />
          ))}
          {expandable
            ? <Grid item className={classes.arrowItem}>
              <img
                src={expanded ? images.arrowOpenBlack : images.arrowClosedBlack}
                height="14px"
                style={{ maxWidth: "14px" }}
                alt="arrow"
                onClick={expandRow}
              />
            </Grid>
            : <Grid item className={classes.arrowItem} />
          }
          <Grid container className={classes.zoneDescription}>
            <Grid item className={classes.zoneText}>
              {get(branch, ["name"]) || "Zone Name"}
            </Grid>
            <Grid item className={classes.zoneTypeText}>
              ({zoneName})
            </Grid>
            <Grid item className={classes.zoneChildCount}>
              {branch["type"]["id"] !== ZONE_TYPE.BIN ? Array.isArray(branch.childs) && `(${branch.childs.length})` : <></>}
            </Grid>
            {branch["pzi_count"] && (ZONE_TYPES_WITH_INVENTORY_ICON.includes(branch["type"]["id"])) ? <Grid item className={classes.zoneChildCount}>
              <img src={images.bin_product_associated} alt="bin" />
            </Grid> : <></>}

          </Grid>
        </Grid>
      </TableCellStyled>
    );
  };

  return (
    <>
      <TableRow
        style={{
          cursor: "pointer",
          backgroundColor: colors.white,
        }}
        hover={true}
        classes={{ hover: classes.tableRowHover }}
        className={get(branch, ["id"]) === selectedZone ? classes.zoneCellSelected : classes.zoneCell}
        onClick={(e) => navigateToBranch(e)}
      >
        {renderZoneRow()}
      </TableRow>
      {expanded &&
        map(get(branch, ["childs"]), (childBranch) => (
          <ZoneTreeRow
            key={get(childBranch, ["id"])}
            branch={{ ...childBranch }}
            depth={depth + 1}
            language={language}
            onExpand={onExpand}
            expandedZones={expandedZones}
            history={history}
            selectedZone={selectedZone}
            goTo={goTo}
            scrollToSelected={scrollToSelected}
            setScrollToSelected={setScrollToSelected}
          />
        )
        )}
    </>
  );
});

export default withRouter(ZoneTreeRow);
